import MiddlewareModule from "modules/Core/core-modules/MiddlewareModule";
import { CYCLES } from "../consts";
import { STAMPS_FRAGMENT } from "modules/Core/consts/graphql";
import { GATEWAY_FRAGMENT } from "modules/roadmaps/middleware";

export const ACTIVITY_FRAGMENT = `
                    id
                    name
                    text
                    boothId
                    parentId
                    gatewayId
                    kind
                    allocated
                    createdAt
                    ${STAMPS_FRAGMENT}
`;

const CYCLE_FRAGMENT = `                    
                    name 
                    text
                    id
                    boothId
                    flow {
                        ${ACTIVITY_FRAGMENT}
                    }
                    createdAt
                    ${STAMPS_FRAGMENT}
`;

export default new MiddlewareModule({
    name: CYCLES,
    operations: {
        create: `
            mutation upsertCycle($input: CycleInput, $id: String) {
                upsertCycle(input: $input, id: $id) {
                    id
                }
            }
        `,
        completeCycle: `
            mutation completeCycle($id: String) {
                completeCycle(id: $id) {
                    id
                }
            } 
        `,
        fetchFeed: `
            query cycles($feedParams: FeedParams, $boothId: String, $isCompleted: Boolean, $isForthcoming: Boolean ) {
                feed: cycles(feedParams: $feedParams, boothId: $boothId, isCompleted: $isCompleted, isForthcoming: $isForthcoming) {
                    entities {
                        ${CYCLE_FRAGMENT}
                    }
                }    
            }
        `,
        fetchCurrentcycle: `
            query currentCycle($boothId: String) {
                currentCycle(boothId: $boothId) {
                    ${CYCLE_FRAGMENT}
                }
            }
        `,
        fetchEntity: `
            query cycle($id: String) {
                entity: cycle(id: $id) {
                    ${CYCLE_FRAGMENT}
                }
            }
        `,
        addGatewayToCycle: `
            mutation addGatewayToCycle($cycleId: String, $gatewayId: String) {
                addGatewayToCycle(cycleId: $cycleId, gatewayId: $gatewayId) {
                    id
                }
            }
        `,
        focusCycle: `
        mutation focusCycle($id: String) {
            focusCycle(id: $id) {
                id
            }
        }
    `,
        fetchActivities: `
            query activities($boothId: String, $unallocated: Boolean, $gatewayId: String) {
                activities(boothId: $boothId, unallocated: $unallocated, gatewayId: $gatewayId) {
                    ${ACTIVITY_FRAGMENT}
                }
            }
        `,
        upsertActivity: `
            mutation upsertActivity($input: ActivityInput, $id: String) {
                upsertActivity(input: $input, id: $id) {
                    ${ACTIVITY_FRAGMENT}
                }
            }
        `,
        stampActivity: `
            mutation stampActivity($id: String, $key: String) {
                stampActivity(id: $id, key: $key) {
                    ${ACTIVITY_FRAGMENT}
                }
            }
        `,
        setCycleFlow: `
            mutation setCycleFlow($cycleId: String, $activityIds: [String]) {
                setCycleFlow(cycleId: $cycleId, activityIds: $activityIds) {
                    id
                    flow {
                        ${ACTIVITY_FRAGMENT}
                    }
                }
            }
        `,
        assignActivityToCycle: `
            mutation assignActivityToCycle($cycleId: String, $placeholderId: String, $activityId: String) {
                assignActivityToCycle(cycleId: $cycleId, placeholderId: $placeholderId, activityId: $activityId) {
                    id
                    flow {
                        ${ACTIVITY_FRAGMENT}
                    }
                }
            }
        `,
    },
    operationsConfig: {
        // fetchEntity: {
        //     paramsParser: ({ id = null }) => ({ boothId: id }),
        // },
    },
});
